export async function getUserSalaryGroup() {
  const groupItems = sessionStorage.getItem('usergroup');
  if (!groupItems) {
    return false; // Handle the case where 'usergroup' is not set in sessionStorage.
  }

  try {
    const arrGroup = JSON.parse(groupItems);
    const groups = JSON.parse(process.env.REACT_APP_SECGROUPS_SALARYREQUEST);
    const temp = [];

    for (const item of arrGroup) {
      if (groups.includes(item)) {
        temp.push(item);
      }
    }

    return temp.length > 0;
  } catch (error) {
    return false; // Handle JSON parsing errors, e.g., if 'usergroup' is not valid JSON.
  }
}

export async function getUserSupperAdminHrmibleGroup() {
  const groupItems = sessionStorage.getItem('usergroup');
  if (!groupItems) {
    return false;
  }

  try {
    const arrGroup = JSON.parse(groupItems);
    const groups = JSON.parse(process.env.REACT_APP_SECGROUPS_Supper_Admin_Hrmobile);
    const temp = [];

    for (const item of arrGroup) {
      if (groups.includes(item)) {
        temp.push(item);
      }
    }

    return temp.length > 0;
  } catch (error) {
    return false;
  }
}
